import {
    AuthenticationResult,
    EventMessage,
    EventType,
    PublicClientApplication,
    IPublicClientApplication
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { createRoot } from "react-dom/client";
import App from './App';
import { msalConfig } from "./AuthConfig";
import { LoginUser, isRunningInTeams } from './services/AppOwnsDataWebApi';
import { app } from "@microsoft/teams-js";

export let msalInstance: IPublicClientApplication = null;
let userLoginProcessed = false;

const root = createRoot(document.getElementById('root')!);

async function initializeMsal() {
    const msalInst = await PublicClientApplication.createPublicClientApplication(msalConfig);
    msalInstance = msalInst;

    msalInst.addEventCallback(async (event: EventMessage) => {
        if (
            event.eventType === EventType.LOGIN_SUCCESS ||
            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
        ) {
            const payload = event.payload as AuthenticationResult;
            if (payload?.account) {
                msalInst.setActiveAccount(payload.account);
                if (!userLoginProcessed) {
                    userLoginProcessed = true;
                    await LoginUser(payload.account.username, payload.account.name);
                }
            }
        }
    });

    return msalInst;
}

(async () => {

    let initialAuthState: {
        isTeamsAuthenticated: boolean;
        teamsUser: { userPrincipalName: string; displayName: string } | null;
    } = {
        isTeamsAuthenticated: false,
        teamsUser: null
    };

    const isTeams = await isRunningInTeams();
    await initializeMsal();

    if (isTeams) {
        try {
            await app.initialize();
            const context = await app.getContext();

            await LoginUser(context.user.userPrincipalName, context.user.displayName);

            initialAuthState = {
                isTeamsAuthenticated: true,
                teamsUser: {
                    userPrincipalName: context.user.userPrincipalName,
                    displayName: context.user.displayName
                }
            };

            root.render(
                <MsalProvider instance={msalInstance}>
                    <App initialAuthState={initialAuthState} />
                </MsalProvider>
            );
        } catch (err) {
            console.error("Teams auth failed", err);
        }
    } else {
        const response = await msalInstance.handleRedirectPromise();

        if (response?.account) {
            msalInstance.setActiveAccount(response.account);
        }

        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
            await LoginUser(accounts[0].username, accounts[0].name);
        } else {
            await msalInstance.loginRedirect();
            return;
        }

        root.render(
            <MsalProvider instance={msalInstance}>
                <App initialAuthState={null} />
            </MsalProvider>
        );
    }
})();
